import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const GetQuoteForm = () => {
    const [travelers, setTravelers] = useState(1);
    const [startDate, setStartDate] = useState("");
    const handleSubmit = (e) => {
        e.preventDefault();
 
      };
    
  return (
    
<div className="col-lg-12">
    <div className="getquote_box bg-white border_setgetting">
   
    <Form id="quoteform" onSubmit={handleSubmit} method="POST">
        <Row>
          <Col lg={12}>
            <div className="form-wrapper form-wrap d-flex gap-xl-3 gap-1">
              <div className="input-group2">
                <label htmlFor="travelers">Travelers</label>
                <div className="number-input position-relative">
                  <Form.Control
                    type="number"
                    className="form-control"
                    id="travelers"
                    value={travelers}
                    onChange={(e) => setTravelers(e.target.value)}
                    min="1"
                    disabled={false} 
                  />
                </div>
              </div>

              <div className="form-wrapper">
                <label htmlFor="start-date">Start Date</label>
                <Form.Control
                  type="date"
                  className="form-control"
                  id="start-date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  min={new Date().toISOString().split("T")[0]}
                  max={new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                    .toISOString()
                    .split("T")[0]}
                  onKeyDown={(e) => e.preventDefault()} 
                  disabled={false} 
                />
              </div>
            </div>
          </Col>

          <Col lg={12} className="mt-3">
            <Button type="submit" className="sent_btn rounded-2">
              Show interest
            </Button>
          </Col>
          <Col xs={12} className="pt-2">
            <div className="text_get">
              {/* <p>
                <span>*</span>Your request will be sent directly to the operator, but you can also contact them
                directly if you prefer.
              </p> */}
            </div>
          </Col>
        </Row>
      </Form>
    </div>

</div>
  );
};

export default GetQuoteForm;
